module.exports = __webpack_public_path__ + "static/img/ch.2d6a379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ch.png
// module id = mZpg
// module chunks = 1